const LAST_VISIT_KEY = 'app_last_visit';
const STALE_THRESHOLD_MS = 12 * 60 * 60 * 1000; // 12 hours

const checkAndRefreshIfStale = () => {
  const now = Date.now();
  const lastVisit = Number(localStorage.getItem(LAST_VISIT_KEY) || 0);

  // Always update the timestamp so next visit calculates from now
  localStorage.setItem(LAST_VISIT_KEY, String(now));

  // First-ever visit: no lastVisit stored, nothing to do
  if (!lastVisit) return;

  // If stale, hard reload to pick up latest deployed assets
  if (now - lastVisit > STALE_THRESHOLD_MS) {
    window.location.reload(true);
  }
};

export default checkAndRefreshIfStale;
